import BaseCdeIcon, { CdeIconProps } from './BaseCdeIcon'
import { ReactComponent as Write } from '../../../assets/permission-icons/write.svg'

const CdeIconWrite: React.FC<CdeIconProps> = ({ status, onClick }) => {
  return <BaseCdeIcon onClick={onClick} status={status} icon={<Write />} />
}

export default CdeIconWrite
